export enum DeviceErrorType {
  Overheating = 1,
  USBWriteFail = 2,
  TurbidostatFailedToControlOD = 3,
  ThermalFuseBlown = 4,
  TemperatureSensorErrorInFlask = 5,
  TemperatureSensorErrorOnHeater = 6,
}

export const DeviceErrorTypeDisplay: Record<DeviceErrorType, string> = {
  [DeviceErrorType.Overheating]: 'Overheating',
  [DeviceErrorType.USBWriteFail]: 'USB write fail',
  [DeviceErrorType.TurbidostatFailedToControlOD]:
    'Turbidostat failed to control OD',
  [DeviceErrorType.ThermalFuseBlown]: 'Thermal fuse blown',
  [DeviceErrorType.TemperatureSensorErrorInFlask]:
    'Temperature sensor error in flask',
  [DeviceErrorType.TemperatureSensorErrorOnHeater]:
    'Temperature sensor error on heater',
};
